import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { NotifyModule } from '../notify/notify.module';

import { CrudBoxComponent } from './crud-box.component';


@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    NotifyModule
  ],
  exports: [CrudBoxComponent],
  declarations: [CrudBoxComponent]
})
export class CrudBoxModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/crud-box/crud-box.module.ts